import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'
import HomeView from '../components/loginPage.vue'
import notificationPage from '../components/notificationPage.vue'
import dashboard from '../components/dashboardPage.vue'
import settingsPage from '../components/settingsPage.vue'
import usersPage from '../components/users/usersPage.vue' // Placeholder for users
import itemPage from '../components/inventory/itemPage.vue'
import branchsPage from '../components/branchs/branchsPage.vue'
import departmentPage from '../components/departments/departmentPage.vue'
import centralkitchenDepartments from '../components/centralKitchen/centralkitchenDepartments.vue'
import centralProducts from '../components/centralKitchen/centralProducts.vue'
import centralInventory from '../components/centralKitchen/centralInventory.vue'
import categoriesPage from '../components/categories/categoriesPage.vue'
import grvPage from '../components/inventory/grvPage.vue'
import storeRequestPage from '../components/inventory/storeRequest.vue'
import approvalPage from '../components/inventory/approvalPage.vue'
import sivPage from '../components/inventory/sivPage.vue'
import nonStockablePage from '../components/inventory/nonStockable.vue'
import returnPage from '../components/inventory/returnPage.vue'
import purchaseRequestPage from '../components/inventory/purchaseRequest.vue'
// import reportListPage from '../components/inventory/reportList.vue'
import grvReportPage from '../components/inventory/report/grvReport.vue'
import balanceReportPage from '../components/inventory/report/balanceReport.vue'
import savedReportPage from '../components/inventory/report/savedReport.vue'
import sivReportPage from '../components/inventory/report/sivReport.vue'
import approvalRequestReportPage from '../components/inventory/report/approvalRequestReport.vue'
import nonStockableReportPage from '../components/inventory/report/nonstockableReport.vue'
import returnReportPage from '../components/inventory/report/returnReport.vue'
import adjustmentReportPage from '../components/inventory/report/adjustmentreport.vue'
import purchaseReportPage from '../components/inventory/report/purchaseReport.vue'
import adjustStockPage from '../components/inventory/adjustStock.vue'
import rolePage from '../components/roles/rolePage.vue'
import menuListPage from '../components/menuList/menuListPage.vue'
import supplierPage from '../components/supplier/supplierPage.vue'
import posPage from '../components/pos/posPage.vue'
import specialOrderPage from '../components/pos/specialOrder.vue'
import specialOrderReportPage from '../components/pos/specialOrderReport.vue'
import displayPage from '../components/pos/displayPage.vue'
import posReportPage from '../components/pos/posReportPage.vue'
import voidPosReportPage from '../components/pos/voidPosReport.vue'
import transferReportPage from '../components/pos/transferReport.vue'
import managementOrderPage from '../components/pos/managementOrder.vue'
import qrScannerPage from '../components/qrScanner.vue'
import barcodeScannerPage from '../components/barcodeScanner.vue'
import billDetailPage from '../components/billDetail.vue'
import financePage from '../components/finance/financePage.vue'
import financeReportPage from '../components/finance/report/financeReportPage.vue'
import hrCompanyProfilePage from '../components/hr/settings/companyProfile.vue'
import hrAnnualLeavingTypePage from '../components/hr/settings/annualLeavingType.vue'
import hrPerformanceCriteriaPage from '../components/hr/settings/performanceCriteria.vue'
import hrWorkOrShiftTimePage from '../components/hr/advancedsetting/workOrShiftTime.vue'
import hrOvertimeTypePage from '../components/hr/advancedsetting/overtimeType.vue'
import hrPaymentTypePage from '../components/hr/advancedsetting/paymentType.vue'
import hrPayrollAndTaxPage from '../components/hr/advancedsetting/payrollAndTax.vue'
import hrFindEmployeePage from '../components/hr/employee/findEmployee.vue'
import hrAnnualLeavingPage from '../components/hr/employee/annualLeaving.vue'
import hrMonthlyConfigurationPage from '../components/hr/attendance/monthlyConfiguration.vue'
import hrAttendancePage from '../components/hr/attendance/attendancePage.vue'
import hrPayrollApprovalPage from '../components/hr/payroll/payrollApproval.vue'
import hrPayrollReportPage from '../components/hr/payroll/payrollReport.vue'
import hrLeavingRequestReportPage from '../components/hr/hrreport/leavingRequestReport.vue'
import hrEvaluationReportPage from '../components/hr/hrreport/evaluationReport.vue'
import hrLetterReportPage from '../components/hr/hrreport/letterReport.vue'

import chooseIngredientPage from '../components/production/register/chooseIngrident.vue'
import recipePage from '../components/production/register/RecipePage.vue'
import dailyTransactionPage from '../components/production/posting/dailyTransaction.vue'
import dailyInventoryPage from '../components/production/posting/dailyInventoryPage.vue'
import dailyProductPage from '../components/production/posting/dailyProductPage.vue'
import consumptionPage from '../components/production/consumption/consumptionPage.vue'
import editAccessPage from '../components/editAccess/editAccess.vue'
import dailyTransactionReportPage from '../components/production/report/dailyTransactionReport.vue'
import materialReportPage from '../components/production/report/materialReport.vue'
import dailyProductReportPage from '../components/production/report/dailyProductReport.vue'
import consumptionReportPage from '../components/production/report/consumptionReport.vue'
import costReportPage from '../components/production/report/costReport.vue'
import grossProfitReportPage from '../components/production/report/grossProfitReport.vue'

import deboniPage1 from "../components/debones/deboniPage.vue"
import deboneCostPage from "../components/debones/deboneCost.vue"
import productPage from '../components/production/register/ProductPage.vue'
import miscellaneousPage from '../components/production/register/MiscellaneousPage.vue'
import materialInventoryPage from '../components/production/material/materialInventory.vue'
import deboneCountPage from '../components/debones/deboneControls.vue'
import deboneInventoryPage from '../components/debones/deboneInventory.vue'
import deboneReportPage from '../components/debones/deboneReport.vue'
import menuEngineeringReportPage from '../components/production/report/menuEngineeringReport.vue'

const routes = [
  {
    path: '/',
    name: 'login',
    component: HomeView,
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: dashboard,
  },

  {
    path: '/production/debone-percentage',
    name: 'debone_percentage',
    component: deboniPage1,
  },
  {
    path: '/production/debone-cost',
    name: 'debone_cost',
    component: deboneCostPage,
  },
  {
    path: '/users',
    name: 'users',
    component: usersPage,
  },
  {
    path: '/inventory/item',
    name: 'item',
    component: itemPage,
  },
  {
    path: '/branchs',
    name: 'branch',
    component: branchsPage,
  },
  {
    path: '/departments',
    name: 'department',
    component: departmentPage,
  },
  {
    path: '/category',
    name: 'category',
    component: categoriesPage,
  },
  {
    path: '/inventory/grv',
    name: 'grv',
    component: grvPage,
  },
  {
    path: '/inventory/store-request',
    name: 'store_request',
    component: storeRequestPage,
  },
  {
    path: '/inventory/approval',
    name: 'approval',
    component: approvalPage,
  },
  {
    path: '/inventory/siv',
    name: 'siv',
    component: sivPage,
  },
  {
    path: '/inventory/non-stockable',
    name: 'non_stockable',
    component: nonStockablePage,
  },
  {
    path: '/inventory/return',
    name: 'return',
    component: returnPage,
  },
  {
    path: '/inventory/purchase-request',
    name: 'purchase_request',
    component: purchaseRequestPage,
  },
  // {
  //   path: '/inventory/report-list',
  //   name: 'report_list',
  //   component: reportListPage,
  // },
  {
    path: '/inventory/report/grv',
    name: 'report_grv',
    component: grvReportPage,
  },
  {
    path: '/inventory/report/balance',
    name: 'report_balance',
    component: balanceReportPage,
  },
  {
    path: '/inventory/report/saved',
    name: 'report_saved',
    component: savedReportPage,
  },
  {
    path: '/inventory/report/siv',
    name: 'report_siv',
    component: sivReportPage,
  },
  {
    path: '/inventory/report/approval-request',
    name: 'report_approval_request',
    component: approvalRequestReportPage,
  },
  {
    path: '/inventory/report/non-stockable',
    name: 'report_non_stockable',
    component: nonStockableReportPage,
  },
  {
    path: '/inventory/report/return',
    name: 'report_return',
    component: returnReportPage,
  },
  {
    path: '/inventory/report/adjustment',
    name: 'report_adjust_stock',
    component: adjustmentReportPage,
  },
  {
    path: '/inventory/report/purchase',
    name: 'report_purchase',
    component: purchaseReportPage,
  },
  {
    path: '/inventory/adjust-stock',
    name: 'adjust_stock',
    component: adjustStockPage,
  },
  {
    path: '/finance',
    name: 'finance',
    component: financePage,
  },
  {
    path: '/finance/report',
    name: 'finance_report',
    component: financeReportPage,
  },
  {
    path: '/hr/settings/company-profile',
    name: 'hr_company_profile',
    component: hrCompanyProfilePage,
  },
  {
    path: '/hr/settings/annual-leaving-type',
    name: 'hr_annual_leaving_type',
    component: hrAnnualLeavingTypePage,
  },
  {
    path: '/hr/settings/performance-criteria',
    name: 'hr_performance_criteria',
    component: hrPerformanceCriteriaPage,
  },
  {
    path: '/hr/advancedsetting/work-or-shift-time',
    name: 'hr_work_shift_time',
    component: hrWorkOrShiftTimePage,
  },
  {
    path: '/hr/advancedsetting/overtime-type',
    name: 'hr_overtime_type',
    component: hrOvertimeTypePage,
  },
  {
    path: '/hr/advancedsetting/payment-type',
    name: 'hr_payment_type',
    component: hrPaymentTypePage,
  },
  {
    path: '/hr/advancedsetting/payroll-and-tax',
    name: 'hr_payroll_tax_setting',
    component: hrPayrollAndTaxPage,
  },
  {
    path: '/hr/employee/find-employee',
    name: 'hr_find_employee',
    component: hrFindEmployeePage,
  },
  {
    path: '/hr/employee/annual-leaving',
    name: 'hr_annual_leaving',
    component: hrAnnualLeavingPage,
  },
  {
    path: '/hr/employee/employee-evaluation',
    name: 'hr_employee_evaluation',
    component: () => import('../components/hr/employee/employeeEvaluation.vue'),
  },
  {
    path: '/hr/employee/employee-letter',
    name: 'hr_employee_letter',
    component: () => import('../components/hr/employee/employeeLetter.vue'),
  },
  {
    path: '/hr/attendance/monthly-configuration',
    name: 'hr_monthly_configuration',
    component: hrMonthlyConfigurationPage,
  },
  {
    path: '/hr/attendance/attendance',
    name: 'hr_attendance_page',
    component: hrAttendancePage,
  },
  {
    path: '/hr/payroll/payroll-approval',
    name: 'hr_payroll_approval',
    component: hrPayrollApprovalPage,
  },
  {
    path: '/hr/payroll/payroll-report',
    name: 'hr_payroll_report',
    component: hrPayrollReportPage,
  },
  {
    path: '/hr/hrreport/leaving-request-report',
    name: 'hr_leaving_request_report',
    component: hrLeavingRequestReportPage,
  },
  {
    path: '/hr/hrreport/evaluation-report',
    name: 'hr_evaluation_report',
    component: hrEvaluationReportPage,
  },
  {
    path: '/hr/hrreport/letter-report',
    name: 'hr_letter_report',
    component: hrLetterReportPage,
  },
  {
    path: '/production',
    name: 'production',
    component: settingsPage,
  },
  {
    path: '/production/register',
    name: 'production_register',
    component: settingsPage,
  },
  {
    path: '/production/register/choose-ingredient',
    name: 'choose_ingredient',
    component: chooseIngredientPage,
  },
  // {
  //   path: '/production/register/debonis',
  //   name: 'production_debonis',
  //   component: deboniPage,
  // },
  {
    path: '/production/register/products',
    name: 'production_register_products',
    component: productPage,
  },
  {
    path: '/production/register/recipe',
    name: 'recipe',
    component: recipePage,
  },
  {
    path: '/production/register/miscellaneous',
    name: 'miscellaneous',
    component: miscellaneousPage,
  },
  {
    path: '/production/posting',
    name: 'production_posting',
    component: settingsPage,
  },
  {
    path: '/production/posting/daily-inventory',
    name: 'daily_inventory',
    component: dailyInventoryPage,
  },
  {
    path: '/production/posting/daily-products',
    name: 'daily_products',
    component: dailyProductPage,
  },
  {
    path: '/production/posting/daily-transaction',
    name: 'daily_transaction',
    component: dailyTransactionPage,
  },
  {
    path: '/production/products',
    name: 'production_products_category',
    component: settingsPage,
  },
  {
    path: '/production/products/distribution',
    redirect: { name: 'product_distribution' },
  },
  {
    path: '/production/products/control',
    redirect: { name: 'items_control' },
  },
  {
    path: '/central-kitchen',
    name: 'central_kitchen',
    component: settingsPage,
  },
  {
    path: '/central-kitchen/cnt-kitchen-departments',
    name: 'cent_kitchen_departments',
    component: centralkitchenDepartments,
  },
  {
    path: '/central-kitchen/departments',
    name: 'central_departments',
    component: centralkitchenDepartments,
  },
  {
    path: '/central-kitchen/products',
    name: 'central_products',
    component: centralProducts,
  },
  {
    path: '/central-kitchen/recipe',
    name: 'central_recipe',
    component: settingsPage,
  },
  {
    path: '/central-kitchen/inventory',
    name: 'central_inventory',
    component: centralInventory,
  },
  {
    path: '/central-kitchen/product-distribution',
    name: 'product_distribution',
    component: () => import('../components/centralKitchen/productDistribution.vue'),
  },
  {
    path: '/central-kitchen/item-controls',
    name: 'items_control',
    component: () => import('../components/centralKitchen/itemControls.vue'),
  },
  {
    path: '/central-kitchen/report/central-cost',
    name: 'central_cost',
    component: () => import('../components/centralKitchen/report/costReport.vue'),
  },
  {
    path: '/central-kitchen/report/product',
    name: 'central_product_report',
    component: () => import('../components/centralKitchen/report/productReport.vue'),
  },
  {
    path: '/central-kitchen/report/items-control',
    name: 'items_control_report',
    component: () => import('../components/centralKitchen/report/itemsControlReport.vue'),
  },
  {
    path: '/production/debonis',
    name: 'production_debonis',
    component: settingsPage,
  },
  {
    path: '/production/debonis/items-count',
    name: 'items_count',
    component: deboneInventoryPage,
  },
  {
    path: '/production/debonis/deboni-distribute',
    name: 'deboni_distribute',
    component: deboneCountPage,
  },
  {
    path: '/production/barbook',
    name: 'production_barbook',
    component: consumptionPage,
  },
  {
    path: '/production/material-inventory',
    name: 'production_material_inventory',
    component: materialInventoryPage,
  },
  {
    path: '/production/edit-access',
    name: 'production_edit_access',
    component: editAccessPage,
  },
  {
    path: '/production/report',
    name: 'production_report',
    component: settingsPage,
  },
  {
    path: '/production/report/transaction',
    name: 'transaction_report',
    component: dailyTransactionReportPage,
  },
  {
    path: '/production/report/material',
    name: 'material_report',
    component: materialReportPage,
  },
  {
    path: '/production/report/product',
    name: 'product_report',
    component: dailyProductReportPage,
  },
  {
    path: '/production/report/cost',
    name: 'cost_report',
    component: costReportPage,
  },
  {
    path: '/production/report/gross-profit',
    name: 'gross_profit_report',
    component: grossProfitReportPage,
  },
  {
    path: '/production/report/bar-book',
    name: 'bar_book_report',
    component: consumptionReportPage,
  },
  {
    path: '/production/report/deboning',
    name: 'deboning_report',
    component: deboneReportPage,
  },
  {
    path: '/production/report/menu-engineering',
    name: 'menu_engineering_report',
    component: menuEngineeringReportPage,
  },
  {
    path: '/pos',
    name: 'pos',
    component: posPage,
  },
  {
    path: '/qr-scanner',
    name: 'qr_scanner',
    component: qrScannerPage,
  },
   {
    path: '/barcode-scanner',
    name: 'barcode_scanner',
    component: barcodeScannerPage,
  },
  {
    path: '/order-detail',
    name: 'bill_detail',
    component: billDetailPage,
  },
  {
    path: '/pos/special-order',
    name: 'pos_special_order',
    component: specialOrderPage,
  },
  {
    path: '/pos/special-order-report',
    name: 'pos_special_order_report',
    component: specialOrderReportPage,
  },
  {
    path: '/pos/display',
    name: 'pos_display',
    component: displayPage,
  },
  {
    path: '/pos/management-order',
    name: 'management_order',
    component: managementOrderPage,
  },
  {
    path: '/pos/transfer-report',
    name: 'pos_transfer_report',
    component: transferReportPage,
  },
  {
    path: '/pos-report',
    name: 'pos_report',
    component: posReportPage,
  },
  {
    path: '/pos/void-report',
    name: 'void_pos_report',
    component: voidPosReportPage,
  },
  {
    path: '/hr',
    name: 'hr',
    component: settingsPage,
  },
  {
    path: '/settings',
    name: 'settings',
    component: settingsPage,
  },
  {
    path: '/roles',
    name: 'roles',
    component: rolePage,
  },
  {
    path: '/menu-list',
    name: 'menu_list',
    component: menuListPage,
  },
  {
    path: '/suppliers',
    name: 'supplier',
    component: supplierPage,
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: notificationPage,
  },
  // {
  //   path: '/waiter',
  //   name: 'waiter_login',
  //   component: () => import('../components/users/waiterLogin.vue'),
  // },
  {
    path: '/password-settings',
    name: 'waiter_settings',
    component: () => import('../components/users/waiterSetting.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

// global navigation guard enforcing authentication
router.beforeEach((to, from, next) => {
  if (to.name !== 'login' && to.name !== 'waiter_login' && to.name !== 'qr_scanner' && to.name !== 'barcode_scanner' && to.name !== 'bill_detail' && !store.getters.isAuthenticated) {
    next({ name: 'login' })
  } else {
    next()
  }
})

export default router
